import React from 'react';
import Profile from '../Profile';

const SuperAdminAccountSettings = () => <Profile />;

export default SuperAdminAccountSettings;
